var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('fragment',[_c('p',{staticClass:"mb-4 text-lg font-bold"},[_vm._v("Available: "+_vm._s(_vm._f("asCurrency")(_vm.paintMoney)))]),_vm._v(" "),(_vm.errorMessage)?_c('p',{staticClass:"mt-2 font-bold text-red-500"},[_vm._v("Error: "+_vm._s(_vm.errorMessage))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }